import useVuelidate from '@vuelidate/core';

import bus from '@/utils/bus';
import { VERIFY_MAIL_TYPES } from '@/utils/constants';

export default {
  name: 'SendVerifyEmail',
  setup() {
    return { sendMailValidator$: useVuelidate({ $lazy: true }) };
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      imgSrc: require('@/assets/images/link-outdated.jpg'),
    };
  },
  beforeDestroy() {
    bus.$emit('CLEAR_TEMP_COMPANY_NAME');
  },
  computed: {
    company() {
      return this.$route?.params.company;
    },
    isTypeSetPwd() {
      const type = this.$route?.params?.type;
      return type === VERIFY_MAIL_TYPES.SET_PASSWORD;
    },
  },
  mounted() {
    if (this.isTypeSetPwd) {
      // eslint-disable-next-line global-require
      this.imgSrc = require('@/assets/images/set-password-link-outdated.jpg');
    }
    if (this.company) {
      bus.$emit('TEMP_COMPANY_NAME', this.company);
    }
  },
};
